import statistics from '../data/statistics';
import _ from 'lodash';

export default {
    /**
     * Method to get final score
     * @param answers
     * @param gpa
     * @param mcat
     * @return {*}
     */
    getFinalScore(answers, gpa, mcat) {
        const answersScore = this.getAnswerScore(answers);
        const statisticsScore = this.getStatisticsScore(gpa, mcat);
        const score = statisticsScore + answersScore;
        if (score > 0) {
            return score;
        }

        return 0;
    },

    /**
     * Calculate statistics score
     * @param gpa
     * @param mcat
     * @return {number}
     */
    getStatisticsScore(gpa, mcat) {
        const statistic = _.find(statistics, statistic => {
            return (
                gpa <= statistic.gpa.max &&
                gpa >= statistic.gpa.min &&
                mcat <= statistic.mcat.max &&
                mcat >= statistic.mcat.min
            );
        });
        return statistic.score * 7;
    },

    /**
     * TODO this can be done better.
     */
    getAnswerScore(answers) {
        let score = 0;
        let research = 1;
        let clinical = 1;
        let shadowing = 1;
        let volunteering = 1;
        let leadership = 1;
        let misc = 1;
        let undergrad = 1;
        let urm = 1;
        let gpaTrend = 1;

        for (let i = 0; i < answers.length; i++) {
            switch (answers[i].method) {
                case 'research':
                    research = answers[i].answer;
                    break;
                case 'clinical':
                    clinical = answers[i].answer;
                    break;
                case 'shadowing':
                    shadowing = answers[i].answer;
                    break;
                case 'volunteering':
                    volunteering = answers[i].answer;
                    break;
                case 'leadership':
                    leadership = answers[i].answer;
                    break;
                case 'misc':
                    misc = answers[i].answer;
                    break;
                case 'undergrad':
                    undergrad = answers[i].answer;
                    break;
                case 'urm':
                    urm = answers[i].answer;
                    break;
                case 'gpaTrend':
                    gpaTrend = answers[i].answer;
                    break;
            }
        }

        score += research * 3;

        score +=
            parseInt(10 * Math.pow(clinical, 2) - 3) / (2 * clinical - 1) -
            12 / clinical -
            Math.abs(5 * clinical - 11);
        score += 11 * shadowing - 16;
        score += volunteering * 2;
        score += leadership * 2;
        score += misc * 3;
        score += (undergrad - 1) * 2;
        score += (urm - 1) * 9;
        score += (gpaTrend - 1) * 5;

        return Math.round(score);
    },

    /**
     * Get the amount of schools for each category of level
     * @param schoolsAmount
     * @param percent
     * @returns {number}
     */
    getSchoolNumberOfPercent(schoolsAmount, percent) {
        return Math.round((percent / 100) * schoolsAmount);
    },

    /**
     * Method to get research score
     * @param answer
     * @return {number}
     */
    researchScore(answer) {
        return answer * 3;
    },

    /**
     * Method to get clinical score
     * @param answer
     * @return {number}
     */
    clinicalScore(answer) {
        return (
            (10 * answer) ** (2 - 3) / (2 * answer - 1) -
            12 / answer -
            Math.abs(5 * answer - 11)
        );
    },

    /**
     * Method to get shadowing score
     * @param answer
     * @return {number}
     */
    shadowingScore(answer) {
        return 11 * answer - 16;
    },

    /**
     * Method to get volunteering score
     * @param answer
     * @return {number}
     */
    volunteeringScore(answer) {
        return answer * 2;
    },

    /**
     * Method to get leadership score
     * @param answer
     * @return {number}
     */
    leadershipScore(answer) {
        return answer * 2;
    },

    /**
     * Method to get misc score
     * @param answer
     * @return {number}
     */
    miscScore(answer) {
        return answer * 3;
    },

    /**
     * Method to get undergrad score
     * @param answer
     * @return {number}
     */
    undergradScore(answer) {
        return (answer - 1) * 2;
    },

    /**
     * Method to get urm score
     * @param answer
     * @return {number}
     */
    urmScore(answer) {
        return (answer - 1) * 9;
    },

    /**
     * Method to get trend score
     * @param answer
     * @return {number}
     */
    gpaTrendScore(answer) {
        return (answer - 1) * 5;
    },
};
